import { useState, useEffect } from 'react'
import { Wifi, WifiOff } from 'lucide-react'

export function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [showOfflineMessage, setShowOfflineMessage] = useState(false)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      setShowOfflineMessage(false)
    }

    const handleOffline = () => {
      setIsOnline(false)
      setShowOfflineMessage(true)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // 如果初始状态是离线，显示提示
    if (!navigator.onLine) {
      setShowOfflineMessage(true)
    }

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  // 在线状态下不显示任何内容
  if (isOnline && !showOfflineMessage) {
    return null
  }

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50">
      <div className={`
        flex items-center space-x-2 px-4 py-2 rounded-lg shadow-lg text-sm font-medium
        ${isOnline 
          ? 'bg-green-500 text-white' 
          : 'bg-red-500 text-white'
        }
        transition-all duration-300
      `}>
        {isOnline ? (
          <>
            <Wifi className="h-4 w-4" />
            <span>网络已恢复</span>
          </>
        ) : (
          <>
            <WifiOff className="h-4 w-4" />
            <span>网络连接异常，正在使用缓存数据</span>
          </>
        )}
      </div>
    </div>
  )
}
